<!-- Topbar Start -->
<div class="navbar-custom">
    <div class="container-fluid">
        <ul class="list-unstyled topnav-menu float-end mb-0">

            <li class="notification-list topbar-dropdown" ngbDropdown>
               <app-restaurant-selection></app-restaurant-selection>
            </li>

            <!-- language switcher (desktop / tablet only) -->
            <li class="dropdown notification-list topbar-dropdown d-none d-lg-block" ngbDropdown>
                <a ngbDropdownToggle class="nav-link me-0 waves-effect waves-light"
                   id="langDropdown" href="javascript:void(0)" aria-expanded="false"
                   [attr.aria-label]="'TOPBAR.LANGUAGE' | translate">
                    <span class="pro-user-name lang-current">
                        <img [src]="langFlags[currentLang]" class="lang-flag" alt="" />
                        {{ 'LANG.' + currentLang | translate }}
                        <i class="mdi mdi-chevron-down"></i>
                    </span>
                </a>
                <div ngbDropdownMenu aria-labelledby="langDropdown" class="dropdown-menu-end lang-dropdown-menu">
                    <a class="lang-item" ngbDropdownItem *ngFor="let lang of availableLangs"
                       (click)="switchLang(lang)" [class.active]="lang === currentLang">
                        <img [src]="langFlags[lang]" class="lang-flag" alt="" />
                        <span class="lang-item-label">{{ 'LANG.' + lang | translate }}</span>
                        <i class="mdi mdi-check lang-check" *ngIf="lang === currentLang"></i>
                    </a>
                </div>
            </li>

            <!-- profile menu (desktop / tablet only) -->
            <li class="dropdown notification-list topbar-dropdown d-none d-lg-block" ngbDropdown>
                <a ngbDropdownToggle class="nav-link nav-user  me-0 waves-effect waves-light" id="profileMenuDropdown"
                    href="javascript:void(0)" aria-expanded="false">
                    <span class="pro-user-name ms-1">
                        {{loggedInUser.name}} <i class="mdi mdi-chevron-down"></i>
                    </span>

                </a>
                <div ngbDropdownMenu aria-labelledby="profileMenuDropdown" class="dropdown-menu-end profile-dropdown">
                    <a class="notify-item" ngbDropdownItem (click)="changePassword()">
                        <i class="fe-lock me-1"></i>
                        <span style="cursor: pointer;">{{ 'TOPBAR.CHANGE_PASSWORD' | translate }}</span>
                    </a>
                    <a class="notify-item" ngbDropdownItem (click)="logout()">
                        <i class="fe-log-out me-1"></i>
                        <span style="cursor: pointer;">{{ 'TOPBAR.LOGOUT' | translate }}</span>
                    </a>
                </div>
            </li>

            <!-- combined account menu (mobile only): language + profile in one dropdown -->
            <li class="dropdown notification-list topbar-dropdown d-block d-lg-none" ngbDropdown>
                <a ngbDropdownToggle class="nav-link nav-user me-0 waves-effect waves-light" id="mobileAccountDropdown"
                   href="javascript:void(0)" aria-expanded="false"
                   [attr.aria-label]="loggedInUser.name">
                    <span class="account-toggle">
                        <i class="mdi mdi-account-circle account-toggle-icon"></i>
                        <i class="mdi mdi-chevron-down"></i>
                    </span>
                </a>
                <div ngbDropdownMenu aria-labelledby="mobileAccountDropdown" class="dropdown-menu-end profile-dropdown mobile-account-menu">
                    <div class="account-header">
                        <i class="mdi mdi-account-circle account-header-icon"></i>
                        <span class="account-header-name">{{ loggedInUser.name }}</span>
                    </div>

                    <h6 class="dropdown-header account-section-title">{{ 'TOPBAR.LANGUAGE' | translate }}</h6>
                    <a class="lang-item" ngbDropdownItem *ngFor="let lang of availableLangs"
                       (click)="switchLang(lang)" [class.active]="lang === currentLang">
                        <img [src]="langFlags[lang]" class="lang-flag" alt="" />
                        <span class="lang-item-label">{{ 'LANG.' + lang | translate }}</span>
                        <i class="mdi mdi-check lang-check" *ngIf="lang === currentLang"></i>
                    </a>

                    <div class="dropdown-divider"></div>
                    <a class="notify-item" ngbDropdownItem (click)="changePassword()">
                        <i class="fe-lock me-1"></i>
                        <span style="cursor: pointer;">{{ 'TOPBAR.CHANGE_PASSWORD' | translate }}</span>
                    </a>
                    <a class="notify-item" ngbDropdownItem (click)="logout()">
                        <i class="fe-log-out me-1"></i>
                        <span style="cursor: pointer;">{{ 'TOPBAR.LOGOUT' | translate }}</span>
                    </a>
                </div>
            </li>


        </ul>

        <ul class="list-unstyled topnav-menu topnav-menu-left m-0">
            <li>
                <button class="button-menu-mobile waves-effect waves-light d-none d-lg-block"
                    (click)="changeSidebarWidth()" *ngIf="layoutType!=='horizontal'">
                    <i class="fe-menu"></i>
                </button>
            </li>

            <li>
                <button class="button-menu-mobile open-left d-block d-lg-none waves-effect waves-light"
                    *ngIf="layoutType!=='horizontal'" (click)="toggleMobileMenu($event)">
                    <i class="fe-menu"></i>
                </button>
            </li>

            <li>
                <!-- Mobile menu toggle (Horizontal Layout)-->
                <a class="navbar-toggle nav-link" [ngClass]="{'open': topnavCollapsed}"
                    (click)="toggleMobileMenu($event)" *ngIf="layoutType==='horizontal'">
                    <div class="lines">
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                </a>
                <!-- End mobile menu toggle-->
            </li>
        </ul>
        <div class="clearfix"></div>
    </div>
</div>
<!-- end Topbar -->
